import { Logo } from "./Logo";

export function Brandmark() {
  return (
    <div className="hstack gap-3">
      <Logo size={28} />
      <div
        style={{
          fontSize: 17,
          letterSpacing: "-0.01em",
          fontWeight: 700,
          color: "var(--brand-green)",
          lineHeight: 1,
        }}
      >
        N-OS
      </div>
    </div>
  );
}
